import { render, staticRenderFns } from "./Titulo.vue?vue&type=template&id=36d61fb1&scoped=true&"
import script from "./Titulo.vue?vue&type=script&lang=js&"
export * from "./Titulo.vue?vue&type=script&lang=js&"
import style0 from "./Titulo.vue?vue&type=style&index=0&id=36d61fb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d61fb1",
  null
  
)

export default component.exports